import { License } from '../domain/License'
import { TidewaysContext } from '../app/context'

export interface NavigationItemFilterCheck {
    license?: License
    isProfilingSpace: boolean
    tidewaysContext: TidewaysContext
}

interface Parameters {
    [key: string]: string | number | undefined
}

export interface NavigationItem {
    label: string
    icon?: string
    route: string
    modal?: boolean
    parameters?: Parameters
    parametersCallback?: (currentOrganization?: string) => Parameters
    supportsAllServices?: boolean
    filterCheck?: (props: NavigationItemFilterCheck) => boolean | undefined
    alternativeRoutes?: { [route: string]: true }
    alwaysSkipHistoryApi?: boolean
}

export const bottomNavigation: NavigationItem[] = [
    {
        route: 'fos_user_profile_show',
        label: 'User',
        icon: 'fa-user',
        alternativeRoutes: {
            'XhprofOrganizationBundle.CliSettings.showToken': true,
            'XhprofOrganizationBundle.CliSettings.createServerToken': true,
            'XhprofOrganizationBundle.CliSettings.createUserToken': true,
            fos_user_profile_show: true,
            'XhprofUserBundle.Settings.integrations': true,
            'XhprofOrganizationBundle.CliSettings.show': true,
            'XhprofOrganizationBundle.Members.invitations': true,
            'XhprofOrganizationBundle.Members.list': true,
            'XhprofUserBundle.IdeIntegration.show': true,
            'XhprofAlertBundle.Configuration.user': true,
            app_2fa_enable: true,
            'XhprofOrganizationBundle.Members.invitationResponse': true,
            'XhprofUserBundle.IdeIntegration.configure': true,
            'XhprofOrganizationBundle.Organization.create': true,
        },
    },
    {
        route: 'XhprofOrganizationBundle.Organization.settings',
        label: 'Settings',
        icon: 'fa-cog',
        parametersCallback: organization => ({
            organization,
        }),
        alternativeRoutes: {
            'XhprofOrganizationBundle.Organization.settings': true,
            'XhprofOrganizationBundle.Partner.index': true,
            'XhprofBillingBundle.Billing.show': true,
            'XhprofOrganizationBundle.Application.createTideways6': true,
            'XhprofOrganizationBundle.Application.create': true,
            'XhprofOrganizationBundle.Organization.delete': true,
            'XhprofAlertBundle.ActionConfiguration.list': true,
            'XhprofUserBundle.ApiToken.list': true,
            'XhprofOrganizationBundle.BetaFeatures.list': true,
            'XhprofOrganizationBundle.SSOAndUserSynchronization.show': true,
            'XhprofOrganizationBundle.Security.settings': true,
            'XhprofOrganizationBundle.Members.show': true,
            'XhprofBillingBundle.Checkout.start': true,
            'XhprofOrganizationBundle.Team.edit': true,
            'XhprofOrganizationBundle.Team.remove': true,
            'XhprofOrganizationBundle.Team.create': true,
            'XhprofBillingBundle.Checkout.changeProjectSize': true,
            'XhprofBillingBundle.Checkout.createSepaPayment': true,
            'XhprofBillingBundle.Billing.cancel': true,
            'XhprofBillingBundle.Billing.resume': true,
            'XhprofBillingBundle.Billing.changeInvoiceEmails': true,
            'XhprofAlertBundle.ActionConfiguration.createActionForm': true,
            'XhprofAlertBundle.ActionConfiguration.create': true,
            'XhprofAlertBundle.ActionConfiguration.editAction': true,
            'XhprofAlertBundle.ActionConfiguration.confirmDeleteAction': true,
            'XhprofUserBundle.ApiToken.create': true,
        },
    },
    {
        route: 'XhprofCoreBundle.help',
        label: 'Help',
        icon: 'fa-question-circle',
        modal: true,
    },
]

// add skipHistoryApi if the user is in an enviorment where react is not used in the main content area
export const shouldSkipHistoryApi = (currentRoute: any): boolean => {
    const applicationSettingRoutes = [
        'XhprofOrganizationBundle.Application.settings',
        'XhprofErrorBundle.Error.listExceptionTracking',
        'XhprofProfilerBundle.Environment.list',
        'XhprofProfilerBundle.Server.list',
        'XhprofProfilerBundle.Service.list',
        'XhprofProfilerBundle.Transaction.list',
        'XhprofAlertBundle.Configuration.list',
        'XhprofOrganizationBundle.Application.installation',
        'XhprofOrganizationBundle.Application.license',
        'XhprofOrganizationBundle.Application.settings',
    ]

    return !!applicationSettingRoutes.find(value => value === currentRoute)
}

export const filterNavigationEntries = (entries: NavigationItem[], props: NavigationItemFilterCheck): NavigationItem[] =>
    entries.filter(entry => (entry.filterCheck ? entry.filterCheck(props) : true))
